<template>
    <div class="main-body">
        <div class="header">
            收银员列表
        </div>
        <div class="out">
            <div class="search2">

                <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                <div style="float:right">
                    <el-input placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                </div>

                <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border
                      style="width: 100%;" :header-cell-style="tabHeader">

                <el-table-column prop="name" label="姓名" ></el-table-column>

                <el-table-column prop="gender" :formatter="genders" label="性别" ></el-table-column>
                <el-table-column prop="phone" label="手机" ></el-table-column>

              <el-table-column label="状态" >
                <template slot-scope="scope">
                  <span v-if="scope.row.status == '1'">正常</span>
                  <span v-if="scope.row.status == '2'">禁用</span>
                </template>
              </el-table-column>

                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>

                      <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>

                    </template>

                </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>



      <el-dialog title="密码修改" :visible.sync="pwdDialog" class="dialog" width='400px' center top='30vh'
                 :close-on-click-modal='false'>
        <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                  show-password></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pwdDialog=false">取 消</el-button>
          <el-button type="primary" @click="editPassword">提交</el-button>
        </div>
      </el-dialog>


    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getStaffDTO} from "@/utils/auth";

    export default {
        name: "Role",
        data() {
            return {

                tableLoading: false,
                showModalEditStaff: false,

                showModalAdd: false,
                showModalEdit: false,

                name: '',
                status: -1,
                tableData: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,

                th: 0,

              pwdDialog: false,
              password: '',
              userCode:'',

            }
        },
        components: {
            Add, Edit
        },
        created() {
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        methods: {

            // 修改table header的背景色
            tabHeader() {
                return 'color:#333;fonts-weight:bold;'
            },

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },

            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },

            genders(row) {
                if (row.gender == 0) {
                    return "女";
                }
                if (row.gender == 1) {
                    return "男";
                }
            },
            getSetTime(row, column, cellValue){
                return timefilters(cellValue)
            },
            serviceStatu(row) {
                if (row.user.status == 1) {
                    return "正常";
                }
                if (row.user.status == 2) {
                    return "禁用";
                }
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1

              //console.log(getStaffDTO());

                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "Cashier/BusinessPage",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        name: this.name,
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                        businessCode:getStaffDTO().businessDTO.businessCode
                    }
                }).then((response) => {
                    this.tableLoading=false
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }
                }).catch(function (error) {
                    this.tableLoading=false
                    console.log(error);
                });
            },


          handlePassword(index,row) {
            this.pwdDialog = true;
            this.userCode = row.userCode;
            this.password = '';
          },
          editPassword() {

            if (this.password.length < 6) {
              this.$message('密码至少为六位')
              return;
            }

            this.$axios({
              method: 'post',
              url: this.$shopUrl + 'User/EditPassword',
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                staffCode: getStaffCode(),
                password: this.password,
                userCode:this.userCode,
              }
            }).then((response) => {
              console.log(response);
              if (response.data.error == 0) {
                this.$message('修改成功');
                this.pwdDialog = false
              } else if (response.data.error == 1) {
                this.$message(response.data.message);
              } else {
                console.log(response.data.message);
              }

            }).catch(function (error) {
              console.log(error);
            });
          },


        }
    }
</script>

<style scoped>

</style>
